import { useCallback } from 'react';
import { Button, type ButtonProps } from '@mantine/core';
import { Download } from 'lucide-react';
import { useDisclosure } from '@mantine/hooks';

import { ImportTemplateModal } from './ImportTemplateModal';

type ImportTemplateButtonProps = {
  onImport: (templateId: string | number) => Promise<void> | void;
  label?: string;
  buttonProps?: ButtonProps;
};

export function ImportTemplateButton({
  onImport,
  label = 'Importa da Template',
  buttonProps,
}: ImportTemplateButtonProps) {
  const [opened, { open, close }] = useDisclosure(false);

  const handleConfirm = useCallback(
    async (templateId: string | number) => {
      await Promise.resolve(onImport(templateId));
      close();
    },
    [close, onImport]
  );

  return (
    <>
      <Button
        size='xs'
        variant='light'
        color='green'
        leftSection={<Download size={14} />}
        onClick={open}
        {...buttonProps}
      >
        {label}
      </Button>

      <ImportTemplateModal
        opened={opened}
        onClose={close}
        onImport={handleConfirm}
      />
    </>
  );
}
